<template>
  <DrawMenu />
</template>

<script>
import DrawMenu from "../components/place/drawactivity/draw_menu.vue";
export default {
  data() {
    return {};
  },
  components: {
    DrawMenu,
  },
};
</script>
<style lang="" scoped></style>
